import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import style from './select.scss';
import omit from 'lodash/omit';
import isUndefined from 'lodash/isUndefined';
import cx from 'classnames';
import isEqual from 'lodash/isEqual';

@CSSModules(style, { allowMultiple: true })
export default class Select extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    formFieldName: PropTypes.string,
    getFormValue: PropTypes.func
  };

  static getDefaultProps = {
    placeholder: 'Select',
    size: 'default'
  };

  get options() {
    const options = this.props.options || [];
    return this.props.withOutPlaceholder ? options : [{ label: this.props.placeholder, value: null, disabled: false }, ...options];
  }

  handleChange(e) {
    this.handleElementChange(e.target);
  }

  handleElementChange(el) {
    const index = parseInt(el.value);
    const option = this.options[index];

    if (this.props.onChange) {
      this.props.onChange(option.value);
    }

    if (this.context.onChange) {
      this.context.onChange(this.context.formFieldName, option.value);
    }
  }

  componentDidMount() {
    this.handleElementChange(this.refs.element);
  }

  _value(props) {
    if(isUndefined(props.value) && this.context.getFormValue) {
      return this.context.getFormValue(this.context.formFieldName);
    } else {
      return props.value;
    }
  }

  get value() {
    return this._value(this.props);
  }

  shouldComponentUpdate(nextProps) {
    return this._value(nextProps) !== this.recentValue || !isEqual(this.props.options, nextProps.options);
  }

  render() {
    this.recentValue = this.value;
    const value = this.recentValue;
    let valueIndex;
    const options = this.options.map((item, index) => {
      if (value === item.value) valueIndex = index;
      return (
        <option
          key={index}
          value={index}
          disabled={item.disabled}
        >
          {item.label}
        </option>
      );
    });

    const props = omit(this.props, 'value', 'onChange');
    const rootStyleName = cx({
      root: true,
      [`size-${this.props.size || 'default'}`]: true,
      muhimma: process.muhimma.indexOf(process.target[0]) !== -1
    });

    return (
      <div styleName={rootStyleName} id={this.props.id}>
        <select
          ref="element"
          value={valueIndex}
          onChange={::this.handleChange}
          style={{...this.props.style}}
        >
          {options}
        </select>
        <div styleName={`border`} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/select.js